<template>
  <div class="spinbutton">
    <label
      :for="id"
      class="visually-hidden"
    >
      {{ label }}
    </label>

    <div class="spinbutton__input-container t-data">
      <input
        :id="id"
        v-model="quantity"
        :name="name"
        :min="min"
        :max="maxComputed"
        :disabled="isDisabled"
        type="number"
        class="spinbutton__input"
      >

      <button
        :disabled="quantity <= min || isDisabled"
        type="button"
        class="spinbutton__input spinbutton__input--decrement"
        aria-hidden="true"
        @click="quantity -= 1"
      />
      
      <button
        :disabled="(maxComputed && quantity >= maxComputed) || isDisabled"
        type="button"
        class="spinbutton__input spinbutton__input--increment"
        aria-hidden="true"
        @click="quantity += 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSpinButton',

  props: {
    id: {
      type: String,
      default: 'Quantity'
    },

    label: {
      type: String,
      required: true
    },

    name: {
      type: String,
      default: 'quantity'
    },

    defaultValue: {
      type: Number,
      default: 1
    },

    min: {
      type: Number,
      default: 1
    },

    max: {
      type: Number,
      default: null
    },

    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  emits: ['quantity'],

  data () {
    return {
      quantity: 1,
      isMax: false
    }
  },

  computed: {
    maxComputed () {
      return this.isMax ? this.defaultValue : this.max
    }
  },

  watch: {
    quantity (value) {
      this.$emit('quantity', value)
    }
  },

  created () {
    this.quantity = this.defaultValue
  },

  methods: {
    /** called from parent component */
    checkForMaximum () {
      // console.log('checkForMaximum')
      
      if (this.quantity > this.defaultValue) {
        this.quantity = this.defaultValue
        this.isMax = true
      }
    }
  }
}
</script>

<style lang="scss">
@import '../scss/utils/variables';
@import '../scss/utils/colors';

.spinbutton {
  width: 100%;
  // &__label {}
  &__input-container {
    display: flex;
    border-radius: $border-radius;
    overflow: hidden;
  }
  &__input {
    display: block;
    position: relative;
    flex: 1;
    width: 100%;
    background-color: $color-light;
    text-align: center;
    padding: $width-gutter-half;
    border: 1px solid $color-light;
    border-radius: 0;
    &:disabled {
      cursor: default;
      opacity: 0.25;
    }
    &:hover,
    &:focus {
      border-color: var(--color-link-highlight);
    }
    &:focus {
      outline: none;
    }
    &[type="number"] {
      &:hover,
      &:focus {
        background-color: var(--color-link-highlight);
        border-color: var(--color-link-highlight);
      }
    }
    &[type="button"] {
      html:not(.touchevents) &:not(:disabled):hover,
      &:not(:disabled):focus {
        background-color: var(--color-link-highlight);
      }
    }
    &--decrement {
      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 1em;
        height: 1px;
        top: 50%;
        left: 50%;
        background-color: currentColor;
        transform: translate(-50%, -50%);
      }
    }
    &--increment {
      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        width: 1em;
        height: 1px;
        top: 50%;
        left: 50%;
        background-color: currentColor;
      }
      &:before {
        transform: translate(-50%, -50%);
      }
      &:after {
        transform: translate(-50%, -50%) rotate(90deg);
      }
    }
  }
}

@media screen and (max-width: $max-width-mobile) {
  .spinbutton {
    &__input-container {
      border-radius: $border-radius-mobile;
    }
    &__input {
      padding: $width-gutter-mobile;
    }
  }
}
</style>